import { render, staticRenderFns } from "./FBData.vue?vue&type=template&id=8dff6d9a&lang=pug"
import script from "./FBData.js?vue&type=script&lang=js&external"
export * from "./FBData.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports